import React from 'react';
import { SearchIcon } from '@primer/octicons-react';
import { TextInput } from '@primer/react';

const IconWrapper = () => (
  <div className="py-1">
    <SearchIcon />
  </div>
)

export const SearchInput = ({
  value,
  onChange,
  className,
  ariaLabel = 'Search',
  placeholder = 'Search',
}) => (
  <TextInput
    className={className}
    sx={{ boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)' }}
    value={value}
    onChange={onChange}
    leadingVisual={IconWrapper}
    aria-label={ariaLabel}
    placeholder={placeholder}
  />
)

export default SearchInput;
